import React from 'react';
import { ExtendedContentContainer,ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import HearingDraft from 'components/HearingDraft';

export const HearingModalComponent = ({ hearingResource, tab }) => {
    return <ExtendedContentContainer extendedContentType={ExtendedContentType.Hearing}>
        <HearingDraft data={hearingResource} defaultTab={tab}/>
    </ExtendedContentContainer>
};